import http from './api'

const route = 'app/comercial/time3/'

export default {
  showDadosEvolucaoTime3: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedores) => {
    return http.post(route + 'showDadosEvolucaoTime3', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedores,
    })
  },

  showDadosEvolucaoTimeVendas: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showDadosEvolucaoTimeVendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showDadosCoberturaVendedor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showDadosCoberturaVendedor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showDetalheCoberturaVendedorTime: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor) => {
    return http.post(route + 'showDetalheCoberturaVendedorTime', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
    })
  },
}
